import React from "react";
import ReactModal from "react-modal";

const darkModeStyles = {
  content: {
    background: "#333",
    color: "#fff",
    borderRadius: "10px",
    padding: "20px",
    width: "80%",
    maxWidth: "700px",
    margin: "0 auto",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
  closeButton: {
    color: "#fff",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    position: "absolute",
    top: "10px",
    right: "10px",
    fontSize: "24px",
  },
  input: {
    background: "#555",
    color: "#fff",
    borderRadius: "5px",
    padding: "5px",
    border: "none",
    marginBottom: "10px",
    width: "100%",
  },
  label: {
    display: "block",
    marginBottom: "5px",
  },
  button: {
    background: "#ccc",
    color: "#333",
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
  },
};

function AssignmentMarkDetails({ isModalOpen, setIsModalOpen, data }) {
  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={setIsModalOpen}
      contentLabel="Form Modal"
      ariaHideApp={false}
      style={darkModeStyles}
    >
      <div
        className="modal-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <h3 className="center">Assignment Details</h3>
        <button
          onClick={() => {
            setIsModalOpen(false);
          }}
        >
          ❌
        </button>
      </div>
      <div className="max-w-lg  mt-8">
        <div>
          <span className="text-cyan">Assignment Title:</span>
          <span className="px-3 ">{data?.title}</span>
        </div>
        <div>
          <span className="text-cyan">Student Name:</span>
          <span className="px-3 ">{data?.student_name}</span>
        </div>
        <div>
          <span className="text-cyan">Total mark:</span>
          <span className="px-3 ">{data?.totalMark}</span>
        </div>
        <div>
          <span className="text-cyan">Repository Link:</span>
          <span className="px-3 ">{data?.repo_link}</span>
        </div>
        <div>
          <span className="text-cyan">Submitted At:</span>
          <span className="px-3 ">
            {new Date(data?.createdAt)?.toLocaleString()}
          </span>
        </div>
        <div>
          <span className="text-cyan">Obtained Mark:</span>
          <span className="px-3 ">{data?.mark || 0}</span>
        </div>
      </div>
    </ReactModal>
  );
}

export default AssignmentMarkDetails;
